import { IsProdMode, ISUAT } from "../../services";
import { featureSelectionConfig } from "../../config/featureSelection.config";
import { isHeaderNavigationItem } from "../../config/headerNavigation.config";
import { handlePortalSelect, redirectToPortal } from "../common/CommonUtils";

/**
 * Returns merged quick services list mapping API menus with feature selection config.
 * Falls back to featureSelectionConfig if API list is not provided.
 */
export const getQuickServicesList = (apiMenus = [], t = (k) => k) => {
  const featureConfigs = featureSelectionConfig(t);

  const getConfigItem = (name = '') => {
    const normalized = String(name).toLowerCase().replace(/[^a-z0-9]/g, '');
    return featureConfigs.find((cfg) => {
      const key = String(cfg.key || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const title = String(cfg.title || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      return (
        normalized === key ||
        normalized === title ||
        normalized.includes(key) ||
        key.includes(normalized) ||
        (normalized.includes('placement') && (key.includes('placement') || title.includes('placement')))
      );
    });
  };

  const list = Array.isArray(apiMenus) && apiMenus.length > 0
    // Items shown as static header links (e.g. AI Career Counsellor) are left out of Quick Services
    ? apiMenus.filter((item) => (item.active ?? true) && !item.deleted
      && !isHeaderNavigationItem(item.name || item.title || item.key))
    : featureConfigs;

  return list.map((item) => {
    const config = getConfigItem(item.name || item.title || item.key);
    const comingSoon = config?.comingSoon ?? item.comingSoon ?? false;
    const resolvedPath = comingSoon
      ? null
      : (ISUAT || IsProdMode)
        ? (item.webRedirectUrl || config?.path)
        : (config?.path || item.webRedirectUrl);

    return {
      ...item,
      id: item.id || config?.key,
      key: config?.key || item.key || item.id,
      title: item.name || config?.title || item.title,
      name: item.name || config?.title || item.title,
      subtitle: config?.subtitle || item.subtitle,
      comingSoon,
      color: config?.color || item.color,
      bg: config?.bg || item.bg,
      path: resolvedPath,
      webRedirectUrl: item.webRedirectUrl,
      enabled: true,
      img: config?.config?.img || item.icon,
      icon: config?.config?.icon || item.icon,
    };
  });
};

/**
 * Centralized navigation handler for Quick Services across Portal Selection, Student Portal & Header.
 */
export const handleQuickServiceNavigation = (service, { navigate, isErpLoggedIn, handlePortalSelect: customHandler } = {}) => {
  if (!service) return;

  if (service.comingSoon) {
    if (customHandler) {
      customHandler(service);
    } else {
      window.location.href = redirectToPortal(isErpLoggedIn, `/coming-soon?portal=${service.key || service.name || ''}`);
    }
    return;
  }

  const targetUrl = (ISUAT || IsProdMode)
    ? (service.webRedirectUrl || service.path)
    : (service.path || service.webRedirectUrl);

  if (ISUAT || IsProdMode) {
    const redirectUrl = service.webRedirectUrl || targetUrl;
    if (redirectUrl) {
      if (service.key) {
        localStorage.setItem('selectedPortal', service.key);
      }
      localStorage.setItem('lastAccessedPortal', redirectUrl);
      window.location.href = redirectUrl;
      return;
    }
  }

  if (customHandler) {
    customHandler({
      ...service,
      path: targetUrl,
    });
    return;
  }

  handlePortalSelect({
    ...service,
    path: targetUrl,
  }, navigate, isErpLoggedIn);
};
